/**
 * DEVELOPMENT/PREVIEW-ONLY escape hatch for the Season x Ability presentation.
 *
 * The production data path is unchanged: DestinationDetail reads
 * useDestinationMonthlyIntelligence -> real Supabase -> SeasonAbilityGraph.
 *
 * This module only returns data when an explicit build-time flag is set
 * (VITE_USE_MONTHLY_INTELLIGENCE_DEV_FIXTURE="true") AND the destination is one
 * of the three approved pilot slugs. It is never a fallback: it does not observe
 * query errors (PGRST205 or otherwise), and it does not activate when the real
 * query returns empty for any other destination.
 *
 * Because the flag is inlined by Vite at build time, the fixture import is
 * dead-code-eliminated from any build where the flag is absent or not "true".
 */
import type { MonthlyIntelligenceRow } from '@/lib/destination-monthly-intelligence';
import { DEV_MONTHLY_INTELLIGENCE_FIXTURE } from '@/pages/dev/__fixtures__/monthly-intelligence.dev-fixture';

const PILOT_SLUGS = ['ericeira', 'santa-teresa', 'siargao'] as const;

export const isMonthlyIntelligenceFixtureEnabled =
  import.meta.env.VITE_USE_MONTHLY_INTELLIGENCE_DEV_FIXTURE === 'true';

export const getPreviewMonthlyIntelligence = (
  slug: string | undefined,
): MonthlyIntelligenceRow[] | null => {
  if (!isMonthlyIntelligenceFixtureEnabled) return null;
  if (!slug || !(PILOT_SLUGS as readonly string[]).includes(slug)) return null;
  return DEV_MONTHLY_INTELLIGENCE_FIXTURE[slug] ?? null;
};
